// Func = limiting Scope for this file
var lastScrollTop = 0;


(function(){

	$(document).ready(function () {

		const burgerMenuBtn = document.getElementById('js-menu-trigger');
		const burgerMenuClose = document.getElementById('js-close-menu');
		const burgerMenu = document.getElementById('burger-menu');

		if(burgerMenuBtn) {
			burgerMenuBtn.addEventListener('click', () =>{
				burgerMenu.classList.add('open');
				document.body.classList.add('no-scroll');
			});

			burgerMenuClose.addEventListener('click', () =>{
				burgerMenu.classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

	});

	window.onload = function() {
		scrollDownAction(40, 'scroll');
		
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
		
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
		
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//Mobile Submenu Funcionality
document.querySelectorAll('.burger-menu__nav > li > a').forEach(link => {
	link.addEventListener('click', e => {
		if (link.nextSibling.nextSibling != null) {
			document.querySelectorAll('.inner > ul > li').forEach(item => {
				if (link.parentNode !== item) item.classList.remove('submenu-show');
			});
			//remove this comment if you want show subnav for mobile
			e.preventDefault();
			link.parentNode.classList.toggle('submenu-show');
			document.querySelector("#mobile-nav-js").classList.toggle('submenu-show')
		}
	});
});

//add class for icon dropdown 
document.querySelectorAll('.burger-menu__nav > li > .sub-sub-menu').forEach(link => {
	let menu = link.parentNode.firstElementChild;
	menu.classList.add('icon-dropdown');
})

